<template>
  <div>
    <span>{{ attributeData.displayName }}</span>
    <v-menu
      ref="menuDateTo"
      :close-on-content-click="false"
      :return-value.sync="value"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined
          append-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          :disabled="isLoading"
          :value="preparedFormatTime"
          :error-messages="errorMessage"
          @change="returnValue"
        />
      </template>
      <v-date-picker
        no-title
        scrollable
        :value="value"
        @change="returnValue"
      >
        <v-spacer/>
        <v-btn
          text
          color="primary"
          @click="$refs.menuDateTo.save(value)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'
import { defaultDateFormat, apiFormat } from '@/configs/date.js'
export default {
  name: 'attribute-field-DATETIME',
  props: {
    attributeData: {
      type: Object,
      default: () => {}
    },
    errorMessage: {
      type: String,
      default: null
    },
    value: {
      type: [String, Date],
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    preparedFormatTime () {
      return moment(this.value || new Date()).format(defaultDateFormat)
    }
  },
  methods: {
    returnValue (value) {
      this.$emit('input', moment(value).format(apiFormat))
    }
  }
}
</script>
